import React from 'react';
import './App.css';
import { useAuth } from './hooks/use-auth';
import Login from './pages/Login';
import Relics from './pages/Relics';
import Header from './ui/Header';
import { UserContext } from './user.context';

function App() {
  const { initializing, user, signOut } = useAuth();

  if (initializing) {
    return <div>Loading...</div>
  }
  return (
    <div className="App">
      {user ? <UserContext.Provider value={{ user }}>
        <Header user={user} onSignout={signOut} />
        <Relics />
      </UserContext.Provider> :
        <Login />
      }
    </div>
  );
}

export default App;
